// extracted by mini-css-extract-plugin
module.exports = {"header":"_1tBT-M","navigation":"Zzp8Cw","content":"R42hzd","logoNavItem":"_1UDHC2","logo":"_37b8OG"};